import { cn } from '../../lib/cn';
import type { HealthScore } from '../../exechome/framework';

type Props = {
  scores: HealthScore[];
  className?: string;
};

function scoreColor(score: number): string {
  if (score >= 85) return 'bg-success-500';
  if (score >= 70) return 'bg-brand-500';
  if (score >= 50) return 'bg-warning-500';
  return 'bg-error-500';
}

function trendColor(trend?: string): string {
  if (!trend) return 'text-slate-500';
  if (trend.startsWith('+')) return 'text-success-600 dark:text-success-400';
  if (trend.startsWith('-')) return 'text-error-600 dark:text-error-400';
  return 'text-slate-500';
}

export function BusinessHealthGrid({ scores, className }: Props) {
  return (
    <div className={cn('grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4', className)}>
      {scores.map((s) => (
        <div key={s.dimension} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between">
            <p className="text-xs font-medium text-slate-600 dark:text-slate-400">{s.label}</p>
            {s.trend && <span className={cn('text-xs font-medium', trendColor(s.trend))}>{s.trend}</span>}
          </div>
          <p className="mt-1 text-2xl font-semibold text-slate-900 dark:text-slate-100">{s.score}</p>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
            <div className={cn('h-full rounded-full transition-all duration-300', scoreColor(s.score))} style={{ width: `${s.score}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
